import { UserSquareIcon } from '@synoptic/ui-kit/icons/react/user-square.tsx';
import { PostTagButton } from '@synoptic/ui-kit/post-tag-button/post-tag-button.tsx';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { subscribersTag } from '@/components/streams/stream-followers/subscribers-tag.css.ts';
import { paths } from '@/routes-utils/paths.ts';
import {
  setStreamUsersType,
  StreamUserType,
} from '@/routes/_app.p.streams_.$id_.users/stream-users-type.ts';

export const StreamSubscribersTag: FC<{
  subscribersCount: number;
  streamId: string;
  isPaid?: boolean;
  disabled?: boolean;
}> = ({ subscribersCount, streamId, isPaid, disabled }) => {
  const navigate = useNavigate();

  return (
    <PostTagButton
      onClick={() => {
        if (!disabled) {
          setStreamUsersType(
            streamId,
            isPaid ? StreamUserType.Subscribers : StreamUserType.Followers,
          );
          navigate(paths.makeStreamUsers(streamId));
        }
      }}
      startIcon={<UserSquareIcon />}
      className={subscribersTag}
      disabled={disabled}
    >
      {subscribersCount +
        (subscribersCount === 1 ? ` subscriber` : ` subscribers`)}
    </PostTagButton>
  );
};
